import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const DropdownBoundTemplateContainer = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "dropdown-bound-template-container",
  },
)`
  position: relative;
  width: 100%;
  overflow: visible;

  /* Find Area is always the first button (slot 0 = 100%) */
  .find-area-button-container {
    position: absolute;
    top: 50%;
    inset-inline-start: 100%;
    margin-inline-start: 8px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    z-index: 1;
  }

  /* Add sits at slot 0 by default; shifts to slot 1 when Find Area is present */
  .add-button-container {
    position: absolute;
    top: 50%;
    inset-inline-start: 100%;
    margin-inline-start: 8px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    z-index: 1;
  }

  &.has-find-area-button .add-button-container {
    inset-inline-start: calc(100% + 48px);
  }

  /* Edit sits at slot 1 by default (Add present, no Find Area) */
  .edit-button-container {
    position: absolute;
    top: 50%;
    inset-inline-start: calc(100% + 48px);
    margin-inline-start: 8px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
    z-index: 1;
  }

  /* No Add, no Find Area → Edit at slot 0 */
  &.no-add-button .edit-button-container {
    inset-inline-start: 100%;
  }

  /* Find Area + Add present → Edit at slot 2 */
  &.has-find-area-button .edit-button-container {
    inset-inline-start: calc(100% + 96px);
  }

  /* Find Area present, no Add → Edit at slot 1 */
  &.has-find-area-button.no-add-button .edit-button-container {
    inset-inline-start: calc(100% + 48px);
  }

  &:hover .edit-button-container {
    opacity: 1;
  }
`;

export const DropdownBoundTemplateWrapper = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "dropdown-bound-template-wrapper",
  },
)`
  width: 100%;
`;

export const NoOptionWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "dropdown-bound-template-wrapper",
})`
  padding: 8px;

  .no-options-create-link {
    border: none;
    background: none;
    color: ${rydeColors.lightBlue};
    cursor: pointer;
  }
`;
